"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9625],{

/***/ 58656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ EmptyCart; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./design_system/components/OFButton/index.ts + 3 modules
var OFButton = __webpack_require__(63773);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./design_system/icons/ExploreIcon.tsx




var SvgExploreIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")")
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M11.425 27.875c-.175 0-.333.133-.341.308v.167a2.753 2.753 0 0 0 2.75 2.75 2.753 2.753 0 0 0 2.75-2.75v-.167c-.009-.175-.167-.308-.342-.308h-4.817ZM26.3 12.867H12.783v-4.35A.52.52 0 0 0 12.267 8h-3.75A.52.52 0 0 0 8 8.517v2.058a.52.52 0 0 0 .517.517H9.7v13.775a.532.532 0 0 0 .525.516h16.242a.5.5 0 0 0 .425-.225L31 19.967a.491.491 0 0 0 .083-.284v-6.3a.52.52 0 0 0-.516-.516h-4.275.008ZM19.784 27.875c-.175 0-.334.133-.342.308v.167a2.753 2.753 0 0 0 2.75 2.75 2.753 2.753 0 0 0 2.75-2.75v-.167c-.008-.175-.167-.308-.342-.308h-4.816Z",
            fill: color || "#595959"
        })
    }));
};
/* harmony default export */ var ExploreIcon = (SvgExploreIcon);

// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
// EXTERNAL MODULE: ./src/constants/url.constants.ts
var url_constants = __webpack_require__(97479);
;// CONCATENATED MODULE: ./components/Checkout/EmptyCart.tsx









var EmptyCart = function() {
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        p: [
            "16px 12px",
            null,
            "32px 24px"
        ],
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
        bg: colors/* colors.white.default */.O.white["default"],
        w: "max-content",
        borderRadius: "8px",
        alignSelf: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                gap: "40px",
                flexDirection: "column",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: "h3",
                        children: t("checkout:empty_cart_title")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExploreIcon, {
                        size: 120,
                        color: colors/* colors.orange.400 */.O.orange[400]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: "body2",
                        children: t("checkout:empty_cart_description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFButton/* OFButton */.Vu, {
                onClick: function() {
                    return router_default().push(url_constants/* URL_EXPLORE */.fZ);
                },
                children: t("checkout:empty_cart_button_text")
            })
        ]
    });
};


/***/ }),

/***/ 19625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hZ": function() { return /* reexport */ Checkout_Checkout; }
});

// UNUSED EXPORTS: CheckoutButtons, CheckoutDueSection, FeedbackSection, RecommendSection, WarningReNewModal

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Swipeable/index.tsx
var components_Swipeable = __webpack_require__(37515);
;// CONCATENATED MODULE: ./components/Checkout/FeedbackSection.tsx





var customSliderDotProps = function(currentIndex, activeIndex) {
    return {
        w: 2,
        h: 2,
        opacity: currentIndex === activeIndex ? 1 : 0.3
    };
};
var customSliderProps = {
    mt: "24px"
};
var FeedbackSection = function() {
    return /*#__PURE__*/ _jsx(Flex, {
        my: "40px",
        children: /*#__PURE__*/ _jsx(Swipeable, {
            itemsToShow: 1,
            showSlider: true,
            showPercent: false,
            customSliderDotProps: customSliderDotProps,
            customSliderProps: customSliderProps,
            children: [
                1,
                2,
                3
            ].map(function(_, index) {
                return(// eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ _jsxs(Flex, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ _jsx(Flex, {
                            mb: "20px",
                            justifyContent: "center",
                            children: Array(5).fill(1).map(function(item, currentIndex) {
                                return(// eslint-disable-next-line react/no-array-index-key
                                /*#__PURE__*/ _jsx(StarIcon, {
                                    m: "2px",
                                    color: "primary.300"
                                }, "star-".concat(currentIndex)));
                            })
                        }),
                        /*#__PURE__*/ _jsx(Flex, {
                            mb: "16px",
                            justifyContent: "center",
                            children: /*#__PURE__*/ _jsx(Text, {
                                fontSize: "xs",
                                whiteSpace: "pre-line",
                                textAlign: "center",
                                children: "“This program has seriously helped me with something I never thought I’d feel comfortable addressing.\n        So thanks for the work you’re doing.”"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Flex, {
                            justifyContent: "center",
                            children: /*#__PURE__*/ _jsx(Text, {
                                fontSize: "sm",
                                fontWeight: "bold",
                                children: "ANDY TAN Y.K, NOAH MEMBER"
                            })
                        })
                    ]
                }, index));
            })
        })
    });
};
/* harmony default export */ var Checkout_FeedbackSection = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(FeedbackSection))));

// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./components/Common/ShopItem/ShopItem.tsx + 1 modules
var ShopItem_ShopItem = __webpack_require__(92197);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
// EXTERNAL MODULE: ./graphql/react-query/index.ts
var react_query = __webpack_require__(41562);
// EXTERNAL MODULE: ./src/states/index.ts + 11 modules
var states = __webpack_require__(64443);
;// CONCATENATED MODULE: ./components/Checkout/RecommendSection.tsx












var NUMBER_OF_ITEMS = 2;
var RecommendSection = function(param) {
    var t = param.t;
    var ref = _sliced_to_array(useRecoilState(suggestionItemsState), 2), suggestionItems = ref[0], setSuggestionItems = ref[1];
    var platform = useRecoilValue(platformState);
    var cart = useRecoilValue(cartState);
    var ref1 = useGetSuggestionsQuery(graphQLClient, {
        input: {
            platform: platform
        }
    }), getSuggestionsData = ref1.data, refetch = ref1.refetch;
    useEffect(function() {
        // TODO: 2 api calls at the initial start. This can only be fixed if we move cart.cartItems as a dependency in graphql api input => it will auto-refetch instead of using useEffect
        refetch();
        setSuggestionItems(getSuggestionsData.getSuggestions || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart.cartItems
    ]);
    return suggestionItems ? /*#__PURE__*/ _jsxs(Flex, {
        justifyContent: "center",
        direction: "column",
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                w: "100%",
                mb: "36px",
                children: [
                    /*#__PURE__*/ _jsx(Flex, {
                        flex: 1,
                        alignItems: "center",
                        children: /*#__PURE__*/ _jsx(Divider, {
                            bg: "primary.300",
                            borderColor: "primary.300",
                            border: "1.5px"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        color: "primary.300",
                        mx: "40px",
                        fontSize: "sm",
                        children: t("other-products-title")
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        flex: 1,
                        alignItems: "center",
                        children: /*#__PURE__*/ _jsx(Divider, {
                            bg: "primary.300",
                            borderColor: "primary.300",
                            border: "1.5px"
                        })
                    })
                ]
            }),
            (suggestionItems === null || suggestionItems === void 0 ? void 0 : suggestionItems.length) > 0 ? /*#__PURE__*/ _jsx(Box, {
                children: /*#__PURE__*/ _jsx(Swipeable, {
                    itemsToShow: NUMBER_OF_ITEMS,
                    showPercent: false,
                    wrapperStyle: {
                        w: "100%"
                    },
                    isDirection: (suggestionItems === null || suggestionItems === void 0 ? void 0 : suggestionItems.length) > NUMBER_OF_ITEMS,
                    children: suggestionItems.map(function(currentItem) {
                        return /*#__PURE__*/ _jsx(ShopItem, _object_spread_props(_object_spread({
                            t: t
                        }, currentItem), {
                            descriptionWrapperMinH: "280px",
                            wrapperStyle: {
                                w: {
                                    base: "auto"
                                },
                                mx: {
                                    base: "5px",
                                    md: "25px"
                                }
                            },
                            hideBuyButton: true,
                            isSuggestion: true
                        }), currentItem.id);
                    })
                })
            }) : /*#__PURE__*/ _jsx(Text, {
                textAlign: "center",
                fontSize: {
                    base: "md",
                    md: "lg"
                },
                children: t("checkout:bought-all-message")
            })
        ]
    }) : null;
};
/* harmony default export */ var Checkout_RecommendSection = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(RecommendSection))));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./components/Loading/index.ts + 3 modules
var Loading = __webpack_require__(14262);
// EXTERNAL MODULE: ./components/MenuBar/CartItem/uscSyncCartHook.ts
var uscSyncCartHook = __webpack_require__(30576);
// EXTERNAL MODULE: ./design_system/components/OFButton/index.ts + 3 modules
var components_OFButton = __webpack_require__(63773);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
// EXTERNAL MODULE: ./src/constants/Common.ts
var Common = __webpack_require__(40330);
// EXTERNAL MODULE: ./src/constants/Countries.ts
var Countries = __webpack_require__(73252);
// EXTERNAL MODULE: ./src/constants/url.constants.ts
var url_constants = __webpack_require__(97479);
// EXTERNAL MODULE: ./src/dataTracking/events.ts
var events = __webpack_require__(26346);
// EXTERNAL MODULE: ./src/dataTracking/segment.ts
var segment = __webpack_require__(99324);
// EXTERNAL MODULE: ./src/hooks/useTrackPageEvent.ts
var useTrackPageEvent = __webpack_require__(15731);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(49384);
// EXTERNAL MODULE: ./src/utils/envConfig.ts
var envConfig = __webpack_require__(83143);
// EXTERNAL MODULE: ./components/Checkout/EmptyCart.tsx + 1 modules
var EmptyCart = __webpack_require__(58656);
// EXTERNAL MODULE: ./components/Checkout/OrderSummary/CheckoutSummaryInfo.tsx + 9 modules
var CheckoutSummaryInfo = __webpack_require__(18285);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./src/utils/getNameProp.ts
var utils_getNameProp = __webpack_require__(44873);
// EXTERNAL MODULE: ./src/utils/priceFormat.ts + 1 modules
var priceFormat = __webpack_require__(69240);
;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/MinimalAmountPaymentNotiSection.tsx









var MinimalAmountPaymentNotiSection = function(param) {
    var t = param.t, display = param.display, minimalAmountPayment = param.minimalAmountPayment;
    if (!display) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        justifyContent: "space-between",
        my: "24px"
    }, (0,utils_getNameProp/* default */.Z)("minimal-amount-payment-notification")), {
        border: "2px solid",
        borderColor: colors/* colors.orange.400 */.O.orange[400],
        borderRadius: "8px",
        padding: "8px 12px",
        mb: "20px",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Icon */.JO, {
                as: ri_index_esm/* RiErrorWarningLine */.j6O,
                mr: "5px",
                color: colors/* colors.orange.400 */.O.orange[400],
                h: "28px",
                w: "28px"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                textStyle: "labels",
                children: t("checkout:minimal-amount-payment-noti", {
                    minimal_amount: (0,priceFormat/* formatPrice */.T)(minimalAmountPayment)
                })
            })
        ]
    }));
};
/* harmony default export */ var OrderSummary_MinimalAmountPaymentNotiSection = (MinimalAmountPaymentNotiSection);

;// CONCATENATED MODULE: ./components/Checkout/hooks/useAddCartFromGuest.ts







var useAddCartFromGuest = function() {
    var guestCheckoutData = (0,es/* useRecoilValue */.sJ)(states/* guestCheckoutDataState */.ce);
    var setIsUpdating = (0,es/* useSetRecoilState */.Zl)(states/* isCartUpdatingState */.O2);
    var setCart = (0,es/* useSetRecoilState */.Zl)(states/* cartState */.dl);
    var setOrderCalculation = (0,es/* useSetRecoilState */.Zl)(states/* orderCalculationState */.jJ);
    var ref = (0,generated.useInsertCartItemByIdMutation)(react_query/* default */.Z), insertCartItemByIdAsync = ref.mutateAsync;
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var priceId, productId, data, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!guestCheckoutData) {
                            _ctx.next = 9;
                            break;
                        }
                        priceId = guestCheckoutData.priceId, productId = guestCheckoutData.productId;
                        setIsUpdating(true);
                        _ctx.next = 5;
                        return insertCartItemByIdAsync({
                            input: {
                                //   id: cart.id,
                                productId: productId,
                                selectedPriceId: priceId,
                                shouldReturnCalculation: true,
                                fbc: localStorage.fbc,
                                fbp: localStorage.fbp
                            }
                        });
                    case 5:
                        data = _ctx.sent;
                        result = data === null || data === void 0 ? void 0 : data.insertCartItemById;
                        if (result) {
                            setCart(result);
                            setOrderCalculation(result.calculation);
                        }
                        setIsUpdating(false);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        guestCheckoutData,
        insertCartItemByIdAsync,
        setCart,
        setIsUpdating,
        setOrderCalculation
    ]);
};

;// CONCATENATED MODULE: ./components/Checkout/Checkout.tsx


























// THANH TODO Refactor the hook
var Checkout = function(param) {
    var t = param.t;
    var isCartUpdating = (0,es/* useRecoilValue */.sJ)(states/* isCartUpdatingState */.O2);
    var patient = (0,es/* useRecoilValue */.sJ)(states/* patientState */.ao);
    var isLoading = (0,uscSyncCartHook/* default */.Z)(true, !isCartUpdating).isLoading;
    useAddCartFromGuest();
    var ref = (0,react.useState)(false), showAlertMsg = ref[0], setShowAlertMsg = ref[1];
    var ref1 = (0,es/* useRecoilValue */.sJ)(states/* orderSummaryState */.mK), items = ref1.items, summary = ref1.summary;
    var onClickCheckout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, userId, ratio, tax, shipping, total, trackedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        userId = patient === null || patient === void 0 ? void 0 : (ref = patient.user) === null || ref === void 0 ? void 0 : ref.id;
                        ratio = (0,envConfig/* stripeCurrencyRatio */.A)();
                        tax = (0,lodash.sum)((summary.itemList || []).map(function(item) {
                            return (0,utils/* getTax */.VT)(item.itemSubTotalAfterDiscount);
                        })) / ratio;
                        shipping = Number(summary.shippingFee || 0) / ratio;
                        total = Number(summary.totalNowAfterCashback) / ratio;
                        trackedData = {
                            userId: userId,
                            anonymousId: !userId ? (0,useTrackPageEvent/* getAnonymousId */.yQ)() : undefined,
                            event: events/* TRACKING_EVENTS_2.checkoutStarted */.er.checkoutStarted,
                            properties: {
                                total: total,
                                tax: tax,
                                revenue: total - shipping - tax,
                                shipping: shipping,
                                discount: Number(summary.discountAmountNow) / ratio,
                                coupon: summary.promotionCode || "",
                                currency: Common/* CURRENT_CURRENCY */.mG,
                                products: items.map(function(item) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
                                    return {
                                        condition: Object.values(((ref = item.product) === null || ref === void 0 ? void 0 : ref.evaluationId) || {}).flat().join(","),
                                        product_id: (ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.id,
                                        sku: (ref2 = item.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.metadata) === null || ref3 === void 0 ? void 0 : ref3.sku,
                                        name: (ref4 = item.product) === null || ref4 === void 0 ? void 0 : ref4.name,
                                        price: Number((ref5 = item.price) === null || ref5 === void 0 ? void 0 : ref5.unit_amount) / ratio,
                                        category: (ref6 = item.product) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.metadata) === null || ref7 === void 0 ? void 0 : ref7.category,
                                        quantity: ((ref8 = item.price) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.metadata) === null || ref9 === void 0 ? void 0 : ref9.dosage) || ((ref10 = item.price) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.metadata) === null || ref11 === void 0 ? void 0 : ref11.boxes) || "",
                                        shipping_frequency: (ref12 = item.price) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.metadata) === null || ref13 === void 0 ? void 0 : ref13.frequency
                                    };
                                }),
                                platform: patient === null || patient === void 0 ? void 0 : patient.fromPlatformEnv
                            }
                        };
                        (0,segment/* track$ */.s)(trackedData);
                        router_default().push(url_constants/* URL_CHECKOUT_DELIVERY */.w0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickCheckout() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (localStorage.getItem("show_checkout_alert_msg") === "1") {
            setShowAlertMsg(true);
            localStorage.removeItem("show_checkout_alert_msg");
        }
    }, [
        setShowAlertMsg
    ]);
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* WholePageLoading */.ok, {});
    if ((items === null || items === void 0 ? void 0 : items.length) === 0) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCart/* EmptyCart */.Q, {});
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        direction: "column",
        children: [
            isCartUpdating && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* WholePageProgress */.Ul, {}),
            showAlertMsg && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                pl: [
                    6,
                    0
                ],
                pr: [
                    6,
                    0
                ],
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                    bg: colors/* colors.green.500 */.O.green[500],
                    flex: 1,
                    color: colors/* colors.white.default */.O.white["default"],
                    fontSize: [
                        "18px",
                        "24px"
                    ],
                    fontWeight: "bold",
                    pt: 3,
                    pb: 3,
                    borderRadius: "6px",
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                    mb: "20px",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: "body3",
                        children: t("checkout:uncheckout-yet")
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                direction: "column",
                mb: "60px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: "h3",
                        textAlign: [
                            "left",
                            null,
                            "center"
                        ],
                        children: t("checkout_summary:confirm_page_title")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Divider */.iz, {
                        m: "40px 0px 12px 0px",
                        borderColor: colors/* colors.grey.900 */.O.grey[900]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckoutSummaryInfo/* CheckoutSummaryInfo */.Q, {
                        summary: summary,
                        items: items
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderSummary_MinimalAmountPaymentNotiSection, {
                        t: t,
                        display: (summary === null || summary === void 0 ? void 0 : summary.minimalAmountPayment) && (summary === null || summary === void 0 ? void 0 : summary.minimalAmountPayment) === (summary === null || summary === void 0 ? void 0 : summary.totalNowAfterCashback),
                        minimalAmountPayment: summary === null || summary === void 0 ? void 0 : summary.minimalAmountPayment
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_OFButton/* FixedButtonsWrapper */.MK, {
                mobileProps: {
                    zIndex: 99
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_OFButton/* OFButton */.Vu, {
                    isDisabled: (items === null || items === void 0 ? void 0 : items.length) === 0,
                    onClick: onClickCheckout,
                    children: t("checkout_summary:".concat(Countries/* CURRENT_COUNTRY */.Ho, "_checkout_button_text"))
                })
            })
        ]
    });
};
/* harmony default export */ var Checkout_Checkout = (Checkout);

// EXTERNAL MODULE: ./components/Checkout/WarningRenewModal.tsx
var WarningRenewModal = __webpack_require__(46653);
// EXTERNAL MODULE: ./components/Checkout/OrderSummary/CheckoutDueSection.tsx + 1 modules
var CheckoutDueSection = __webpack_require__(60599);
;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/CheckoutButtons.tsx










var CheckoutButtons = function(param) {
    var t = param.t, onCheckoutClick = param.onCheckoutClick, items = param.items;
    var isCheckoutButtonLoading = useRecoilValue(isCheckoutButtonLoadingState);
    var areDisabled = useRecoilValue(areDisabledCheckoutButtonsState);
    var isCartUpdating = useRecoilValue(isCartUpdatingState);
    return /*#__PURE__*/ _jsx(Overlay, {
        isLoading: isCartUpdating,
        h: "max-content",
        display: "flex",
        justifyContent: "center",
        children: /*#__PURE__*/ _jsx(Flex, {
            gap: "24px",
            flexDirection: "column",
            alignItems: "center",
            w: "max-content",
            children: /*#__PURE__*/ _jsx(OFButton, _object_spread_props(_object_spread({
                onClick: onCheckoutClick,
                isLoading: isCheckoutButtonLoading,
                isDisabled: (items === null || items === void 0 ? void 0 : items.length) === 0 || areDisabled
            }, getNameProp("checkout-button")), {
                children: t("checkout:".concat(CURRENT_COUNTRY, "_checkout_button_text"))
            }))
        })
    });
};
/* harmony default export */ var OrderSummary_CheckoutButtons = ((/* unused pure expression or super */ null && (CheckoutButtons)));

;// CONCATENATED MODULE: ./components/Checkout/OrderSummary/index.ts




;// CONCATENATED MODULE: ./components/Checkout/index.ts







/***/ }),

/***/ 9266:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/hooks/Cart/useCartHooks.ts
var Cart_useCartHooks = __webpack_require__(95979);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
// EXTERNAL MODULE: ./design_system/components/OFButton/index.ts + 3 modules
var components_OFButton = __webpack_require__(63773);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var components_OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./src/colors.ts
var src_colors = __webpack_require__(52269);
// EXTERNAL MODULE: ./src/constants/Countries.ts
var Countries = __webpack_require__(73252);
;// CONCATENATED MODULE: ./components/Shop/Buttons.tsx








var country = (/* unused pure expression or super */ null && ("sg"));
var Buttons_AddButton = function(_param) {
    var t = _param.t, onClick = _param.onClick, requiresPrescription = _param.requiresPrescription, rest = _object_without_properties(_param, [
        "t",
        "onClick",
        "requiresPrescription"
    ]);
    return /*#__PURE__*/ _jsx(OFButton, _object_spread_props(_object_spread({
        onClick: onClick
    }, rest), {
        children: /*#__PURE__*/ _jsx(OFText, {
            textStyle: "button1",
            color: colors.white.default,
            children: t("shop:".concat(country === COUNTRY_CODES.HK || requiresPrescription ? "add-to-list" : "add-to-cart"))
        })
    }));
};
var Buttons_BuyButton = function(_param) {
    var t = _param.t, requiresPrescription = _param.requiresPrescription, onClick = _param.onClick, rest = _object_without_properties(_param, [
        "t",
        "requiresPrescription",
        "onClick"
    ]);
    return /*#__PURE__*/ _jsx(OFButton, _object_spread_props(_object_spread({
        variant: "primary",
        onClick: onClick
    }, rest), {
        children: /*#__PURE__*/ _jsx(OFText, {
            textStyle: "button1",
            color: colors.white.default,
            children: t("shop:".concat(country === COUNTRY_CODES.HK || requiresPrescription ? "request" : "buy-now"))
        })
    }));
};

;// CONCATENATED MODULE: ./components/Common/ShopItem/ButtonSection.tsx










var ButtonSection = function(param) {
    var t = param.t, requiresPrescription = param.requiresPrescription, productProps = param.productProps, _hideBuyButton = param.hideBuyButton, hideBuyButton = _hideBuyButton === void 0 ? false : _hideBuyButton, hideAddbutton = param.hideAddbutton, _fromThankYou = param.fromThankYou, fromThankYou = _fromThankYou === void 0 ? false : _fromThankYou, _isSuggestion = param.isSuggestion, isSuggestion = _isSuggestion === void 0 ? false : _isSuggestion, buttonDirection = param.buttonDirection, onClickBuyButton = param.onClickBuyButton, _teleConsultOrders = param.teleConsultOrders, teleConsultOrders = _teleConsultOrders === void 0 ? [] : _teleConsultOrders, excludedEvalIds = param.excludedEvalIds;
    var ref;
    var isMobile = useBreakpointValue({
        base: true,
        md: false
    });
    var ref1 = useCartHooks(isSuggestion, excludedEvalIds), onAddToCartClick = ref1.onAddToCartClick, onBuyNowClick = ref1.onBuyNowClick, onThankYouAddToCartClick = ref1.onThankYouAddToCartClick, onThankYouBuyNowClick = ref1.onThankYouBuyNowClick, completedEvalIds = ref1.completedEvalIds, skippedEvalIds = ref1.skippedEvalIds, platform = ref1.platform;
    // after doctor approve meds (skip meds selection flow)
    var completedConsultEvalIDs = teleConsultOrders.filter(function(o) {
        return o.status === OrderStatus.Deleted;
    }).map(function(o) {
        return o.evaluationId;
    });
    var showAddButton = !requiresPrescription || uniq(_to_consumable_array(completedEvalIds).concat(_to_consumable_array(skippedEvalIds), _to_consumable_array(completedConsultEvalIDs))).includes(productProps === null || productProps === void 0 ? void 0 : (ref = productProps.evaluationId) === null || ref === void 0 ? void 0 : ref[platform]);
    if (hideAddbutton !== undefined) {
        showAddButton = !hideAddbutton;
    }
    var clickBuyButton = function() {
        if (onClickBuyButton) {
            onClickBuyButton(productProps);
            return;
        }
        if (fromThankYou) {
            onThankYouBuyNowClick(productProps);
            return;
        }
        onBuyNowClick(productProps);
    };
    var direction = useMemo(function() {
        if (buttonDirection) {
            return buttonDirection;
        }
        if (hideBuyButton) {
            return "column";
        }
        return [
            "column",
            "row"
        ]; // responsive
    }, [
        buttonDirection,
        hideBuyButton
    ]);
    return /*#__PURE__*/ _jsxs(Flex, {
        alignItems: hideBuyButton ? "flex-start" : "center",
        direction: direction,
        w: buttonDirection === "column" ? "100%" : showAddButton ? "100%" : "50%",
        gap: "12px",
        sx: buttonDirection !== "column" && {
            "& [role=cartCTA] + [role=cartCTA]": {
                ml: [
                    0,
                    "12px"
                ],
                mt: [
                    "12px",
                    0
                ]
            }
        },
        children: [
            showAddButton && /*#__PURE__*/ _jsx(AddButton, _object_spread({
                t: t,
                onClick: function() {
                    return fromThankYou ? onThankYouAddToCartClick(productProps) : onAddToCartClick(productProps);
                },
                product: productProps,
                hideBuyButton: hideBuyButton,
                requiresPrescription: requiresPrescription
            }, (buttonDirection === "column" || isMobile) && {
                width: "100%"
            }, getNameProp("add-button-section"))),
            !hideBuyButton && /*#__PURE__*/ _jsx(BuyButton, _object_spread({
                onClick: clickBuyButton,
                t: t,
                showAddButton: showAddButton,
                requiresPrescription: requiresPrescription
            }, (buttonDirection === "column" || isMobile) && {
                width: "100% !important"
            }, getNameProp("buy-button-section")))
        ]
    });
};
/* harmony default export */ var ShopItem_ButtonSection = ((/* unused pure expression or super */ null && (ButtonSection)));


/***/ }),

/***/ 92197:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var recoil_es = __webpack_require__(4480);
// EXTERNAL MODULE: ./components/Common/ShopItem/ButtonSection.tsx + 1 modules
var ShopItem_ButtonSection = __webpack_require__(9266);
// EXTERNAL MODULE: ./components/hooks/Localization/useProductLocalization.ts
var Localization_useProductLocalization = __webpack_require__(54653);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var components_OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
// EXTERNAL MODULE: ./src/colors.ts
var src_colors = __webpack_require__(52269);
;// CONCATENATED MODULE: ./components/Common/ShopItem/PriceFormat.tsx









var PriceFormat_PriceFormat = function(param) {
    var t = param.t, fallbackPrice = param.fallbackPrice, displayId = param.displayId;
    var getTranslatedText = useProductLocalization().getTranslatedText;
    var displayPriceText = getTranslatedText(displayId, StripeProductLocaleKeys.DisplayPrice);
    var quantityPerUnitText = getTranslatedText(displayId, StripeProductLocaleKeys.QuantityPerUnit);
    var displayPrice = displayPriceText === "" ? fallbackPrice : displayPriceText;
    var unit = quantityPerUnitText === "" ? getTranslatedText(displayId, StripeProductLocaleKeys.Unit) : quantityPerUnitText;
    return /*#__PURE__*/ _jsxs(Flex, _object_spread_props(_object_spread({}, getNameProp("product-price-quantity")), {
        children: [
            /*#__PURE__*/ _jsx(OFText, {
                color: colors.white.default,
                textStyle: "body3",
                children: t("shop:from_price_format", {
                    price: displayPrice
                })
            }),
            /*#__PURE__*/ _jsxs(OFText, {
                color: colors.white.default,
                textStyle: "body3",
                children: [
                    "\xa0/ ",
                    unit
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/Common/ShopItem/hooks.ts
var hooks = __webpack_require__(48868);
// EXTERNAL MODULE: ./src/dataTracking/index.ts
var dataTracking = __webpack_require__(43988);
// EXTERNAL MODULE: ./src/dataTracking/events.ts
var events = __webpack_require__(26346);
// EXTERNAL MODULE: ./src/states/index.ts + 11 modules
var states = __webpack_require__(64443);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(49384);
;// CONCATENATED MODULE: ./components/Common/ShopItem/ShopItem.tsx



















var ShopItem = function(_param) {
    var t = _param.t, wrapperStyle = _param.wrapperStyle, descriptionWrapperMinH = _param.descriptionWrapperMinH, isAdded = _param.isAdded, _hideBuyButton = _param.hideBuyButton, hideBuyButton = _hideBuyButton === void 0 ? false : _hideBuyButton, _fromThankYou = _param.fromThankYou, fromThankYou = _fromThankYou === void 0 ? false : _fromThankYou, _isSuggestion = _param.isSuggestion, isSuggestion = _isSuggestion === void 0 ? false : _isSuggestion, customButtonSection = _param.customButtonSection, _teleConsultOrders = _param.teleConsultOrders, teleConsultOrders = _teleConsultOrders === void 0 ? [] : _teleConsultOrders, excludedEvalIds = _param.excludedEvalIds, productProps = _object_without_properties(_param, [
        "t",
        "wrapperStyle",
        "descriptionWrapperMinH",
        "isAdded",
        "hideBuyButton",
        "fromThankYou",
        "isSuggestion",
        "customButtonSection",
        "teleConsultOrders",
        "excludedEvalIds"
    ]);
    var name = productProps.name, image = productProps.image, id = productProps.id, _metadata = productProps.metadata, tmp = _metadata.requires_prescription, requiresPrescription = tmp === void 0 ? true : tmp, _category = _metadata.category, category = _category === void 0 ? [] : _category, _sku = _metadata.sku, sku = _sku === void 0 ? "" : _sku;
    var getTranslatedText = useProductLocalization().getTranslatedText;
    var ref = useShopItemHook(), isMobile = ref.isMobile, setProductDetailState = ref.setProductDetailState, setIsDetailModalOpened = ref.setIsDetailModalOpened, fallbackPrice = ref.fallbackPrice, platform = ref.platform;
    var patient = useRecoilValue(patientState);
    return /*#__PURE__*/ _jsxs(Flex, _object_spread_props(_object_spread({
        bg: "white",
        borderRadius: "8px",
        direction: "column",
        w: "auto",
        h: "100%",
        minH: [
            100,
            430,
            430
        ],
        padding: {
            base: "10px",
            md: "20px"
        },
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        justifyContent: "space-between"
    }, getNameProp("product-card"), wrapperStyle), {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                direction: "column",
                alignItems: "space-between",
                mb: "4px",
                flex: 1,
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        direction: "column",
                        flex: 1,
                        minH: descriptionWrapperMinH !== null && descriptionWrapperMinH !== void 0 ? descriptionWrapperMinH : {
                            base: "235px",
                            md: "320px"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                w: "auto",
                                h: {
                                    base: "90px",
                                    md: "140px"
                                },
                                src: getImageUrlFromImageModel(image, platform, false),
                                alt: name,
                                objectFit: "cover",
                                mb: {
                                    base: "10px",
                                    md: "20px"
                                },
                                borderRadius: "8px"
                            }),
                            /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({
                                fontFamily: "heading",
                                fontWeight: "500",
                                fontSize: [
                                    "18px",
                                    "24px"
                                ],
                                mb: {
                                    base: "4px",
                                    md: "8px"
                                },
                                color: platform === "zoey" ? "primary.500" : "inherit"
                            }, getNameProp("product-menu")), {
                                children: /*#__PURE__*/ _jsx(Trans, {
                                    components: {
                                        br: /*#__PURE__*/ _jsx("br", {})
                                    },
                                    children: getTranslatedText(id, StripeProductLocaleKeys.ProductName)
                                })
                            })),
                            /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({
                                fontSize: {
                                    base: "xs",
                                    md: "sm"
                                },
                                maxHeight: "normal",
                                lineHeight: "normal",
                                mb: {
                                    base: "8px",
                                    md: "12px"
                                }
                            }, getNameProp("product-description")), {
                                children: /*#__PURE__*/ _jsx(Trans, {
                                    components: {
                                        br: /*#__PURE__*/ _jsx("br", {})
                                    },
                                    children: getTranslatedText(id, StripeProductLocaleKeys.ProductDescription)
                                })
                            })),
                            /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({
                                alignItems: "flex-end",
                                mb: "5px",
                                cursor: "pointer",
                                onClick: function() {
                                    setProductDetailState(productProps);
                                    setIsDetailModalOpened(true);
                                    var trackingMetadata = {
                                        "Product Name": name,
                                        "Product Category": category === null || category === void 0 ? void 0 : category.split(","),
                                        Prescription: requiresPrescription,
                                        "Product SKU": sku,
                                        "Suggested Product": isSuggestion
                                    };
                                    track(TRACKING_EVENTS.VIEW_DETAIL, trackingMetadata, patient);
                                }
                            }, getNameProp("product-learn-more")), {
                                children: /*#__PURE__*/ _jsx(Text, {
                                    fontSize: {
                                        base: "8px",
                                        md: "12px"
                                    },
                                    lineHeight: "normal",
                                    color: platform === PlatformType.Noah ? "primary.500" : "primaryTwo.500",
                                    textDecoration: "underline",
                                    fontWeight: "semibold",
                                    pt: "2px",
                                    children: t("shop:shop-item-learn-more")
                                })
                            }))
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        direction: "column",
                        children: [
                            requiresPrescription && !isMobile && /*#__PURE__*/ _jsx(Flex, {
                                mb: "12px",
                                children: /*#__PURE__*/ _jsx(ConsultTag, {
                                    isMobile: isMobile,
                                    children: t("shop:prescription-only")
                                })
                            }),
                            /*#__PURE__*/ _jsx(PriceFormat, {
                                displayId: id,
                                fallbackPrice: fallbackPrice,
                                t: t
                            })
                        ]
                    })
                ]
            }),
            isAdded ? /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({}, getNameProp("added-label")), {
                children: t("shop:added-to-cart-label")
            })) : customButtonSection || /*#__PURE__*/ _jsx(ButtonSection, {
                t: t,
                requiresPrescription: requiresPrescription,
                productProps: productProps,
                hideBuyButton: hideBuyButton,
                fromThankYou: fromThankYou,
                isSuggestion: isSuggestion,
                teleConsultOrders: teleConsultOrders,
                excludedEvalIds: excludedEvalIds
            })
        ]
    }));
};
/* harmony default export */ var ShopItem_ShopItem = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ShopItem))));


/***/ }),

/***/ 48868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51469);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var src_states__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64443);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49384);





var useShopItemHook = function() {
    var ref, ref1, ref2, ref3;
    var isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useBreakpointValue */ .Sx)({
        base: true,
        md: false
    });
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_1__/* .productDetailState */ .K5), 2), productDetail = ref4[0], setProductDetailState = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_1__/* .isDetailModalOpenedState */ .Am), 2), isDetailModalOpened = ref5[0], setIsDetailModalOpened = ref5[1];
    var addedProducts = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_1__/* .addedProductsState */ .f_);
    var platform = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_1__/* .platformState */ .QQ);
    var ref6;
    var requiresPrescription = (ref6 = productDetail === null || productDetail === void 0 ? void 0 : (ref = productDetail.metadata) === null || ref === void 0 ? void 0 : ref.requires_prescription) !== null && ref6 !== void 0 ? ref6 : true;
    var ref7;
    var fallbackPrice = (0,src_utils__WEBPACK_IMPORTED_MODULE_2__/* .addCurrencyPrefix */ .US)((ref7 = productDetail === null || productDetail === void 0 ? void 0 : (ref1 = productDetail.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.metadata) === null || ref3 === void 0 ? void 0 : ref3.frequency_actual_price_display) !== null && ref7 !== void 0 ? ref7 : "");
    var isAdded = addedProducts.includes(productDetail === null || productDetail === void 0 ? void 0 : productDetail.id);
    return {
        isMobile: isMobile,
        productDetail: productDetail,
        setProductDetailState: setProductDetailState,
        setIsDetailModalOpened: setIsDetailModalOpened,
        isDetailModalOpened: isDetailModalOpened,
        requiresPrescription: requiresPrescription,
        fallbackPrice: fallbackPrice,
        isAdded: isAdded,
        platform: platform
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useShopItemHook);


/***/ }),

/***/ 30576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4480);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12705);
/* harmony import */ var graphql_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41562);
/* harmony import */ var src_states__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64443);







var useSyncCartHook = function() {
    var shouldReturnCalculation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, shouldFetchCart = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var setCart = (0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_4__/* .cartState */ .dl);
    var setOrderCalculation = (0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_4__/* .orderCalculationState */ .jJ);
    var ref = (0,graphql_generated__WEBPACK_IMPORTED_MODULE_2__.useGetCartQuery)(graphql_react_query__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        input: {
            shouldReturnCalculation: shouldReturnCalculation
        }
    }, {
        enabled: shouldFetchCart,
        refetchOnWindowFocus: true
    }), cartData = ref.data, refetch = ref.refetch, isLoading = ref.isLoading;
    var updateCartAndCalculation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var cartFromDB = cartData === null || cartData === void 0 ? void 0 : cartData.getCart;
        if (!cartFromDB) {
            return;
        }
        setCart((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, cartFromDB), {
            isLoading: false
        }));
        if (cartFromDB === null || cartFromDB === void 0 ? void 0 : cartFromDB.calculation) {
            setOrderCalculation(cartFromDB.calculation);
        }
    }, [
        cartData === null || cartData === void 0 ? void 0 : cartData.getCart,
        setCart,
        setOrderCalculation
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        updateCartAndCalculation();
    }, [
        cartData,
        updateCartAndCalculation
    ]);
    return {
        refetch: refetch,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSyncCartHook);


/***/ }),

/***/ 37515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28485);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24198);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_swipeable_views__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77314);
/* harmony import */ var react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42850);
/* harmony import */ var timers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(602);
/* harmony import */ var timers__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(timers__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18467);
/* eslint-disable react/no-array-index-key */ /* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-nocheck












var Swipeable = function(_param) {
    var _showPercent = _param.showPercent, showPercent = _showPercent === void 0 ? true : _showPercent, _showSlider = _param.showSlider, showSlider = _showSlider === void 0 ? false : _showSlider, _itemsToShow = _param.itemsToShow, itemsToShow = _itemsToShow === void 0 ? 1 : _itemsToShow, children = _param.children, _spacing = _param.spacing, spacing = _spacing === void 0 ? 2 : _spacing, _isAuto = _param.isAuto, isAuto = _isAuto === void 0 ? false : _isAuto, _isDirection = _param.isDirection, isDirection = _isDirection === void 0 ? false : _isDirection, _customSliderDotProps = _param.customSliderDotProps, customSliderDotProps = _customSliderDotProps === void 0 ? function() {
        return null;
    } : _customSliderDotProps, _customSliderProps = _param.customSliderProps, customSliderProps = _customSliderProps === void 0 ? {} : _customSliderProps, _customNextButtonProps = _param.customNextButtonProps, customNextButtonProps = _customNextButtonProps === void 0 ? {} : _customNextButtonProps, _customPrevButtonProps = _param.customPrevButtonProps, customPrevButtonProps = _customPrevButtonProps === void 0 ? {} : _customPrevButtonProps, wrapperStyle = _param.wrapperStyle, _dotColor = _param.dotColor, dotColor = _dotColor === void 0 ? "primary.300" : _dotColor, _isManualAuto = _param.isManualAuto, isManualAuto = _isManualAuto === void 0 ? false : _isManualAuto, _isDirectionButtonsOverlap = _param.isDirectionButtonsOverlap, isDirectionButtonsOverlap = _isDirectionButtonsOverlap === void 0 ? false : _isDirectionButtonsOverlap, activeIdx = _param.activeIdx, callbackFunc = _param.callbackFunc, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "showPercent",
        "showSlider",
        "itemsToShow",
        "children",
        "spacing",
        "isAuto",
        "isDirection",
        "customSliderDotProps",
        "customSliderProps",
        "customNextButtonProps",
        "customPrevButtonProps",
        "wrapperStyle",
        "dotColor",
        "isManualAuto",
        "isDirectionButtonsOverlap",
        "activeIdx",
        "callbackFunc"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(20), percent = ref[0], setPercent = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), activeIndex = ref1[0], setActiveIndex = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var index = Math.floor(activeIdx / itemsToShow);
        var timeout = index === activeIndex ? 0 : 800;
        if (activeIdx || activeIdx === 0) {
            setActiveIndex(index);
            (0,timers__WEBPACK_IMPORTED_MODULE_4__.setTimeout)(callbackFunc, timeout);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeIdx
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setPercent(itemsToShow * (activeIndex + 1) * 100 / 5);
    }, [
        activeIndex,
        itemsToShow
    ]);
    (0,src_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useInterval */ .Yz)(function() {
        if (isManualAuto) // eslint-disable-next-line no-unsafe-optional-chaining
        setActiveIndex(function(currentActiveIndex) {
            return currentActiveIndex === (pages === null || pages === void 0 ? void 0 : pages.length) - 1 ? 0 : currentActiveIndex + 1;
        });
    }, 3000);
    if (!children) return null;
    if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isArray(children)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
            width: "100%",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                flex: "1",
                children: children
            })
        });
    }
    var pages = lodash__WEBPACK_IMPORTED_MODULE_0___default().chunk(children, itemsToShow);
    var MainSwipeable = isAuto ? (0,react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_3__/* .autoPlay */ .bH)(react_swipeable_views__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP) : react_swipeable_views__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP;
    var handleChangeSlide = function(direction) {
        if (direction === "prev" && activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
        if (direction === "next" && pages.length > activeIndex + 1) {
            setActiveIndex(activeIndex + 1);
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        position: "relative"
    }, props), {
        children: [
            isDirection && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        className: "nextSwipeable",
                        position: "absolute",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        top: [
                            "calc(50% - 11px)",
                            "calc(50% - 12px)"
                        ],
                        right: isDirectionButtonsOverlap ? "-30px" : [
                            "0",
                            "-48px"
                        ],
                        zIndex: "1",
                        background: "white",
                        color: "primary.500",
                        _hover: {
                            color: "primaryTwo.500",
                            background: "white"
                        },
                        fontSize: [
                            "22px",
                            "24px"
                        ],
                        borderRadius: "50%",
                        width: [
                            "35px",
                            "37px"
                        ]
                    }, customNextButtonProps), {
                        onClick: function() {
                            return handleChangeSlide("next");
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_12__/* .ChevronRightIcon */ .XC, {})
                    })),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        className: "prevSwipeable",
                        position: "absolute",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        top: [
                            "calc(50% - 11px)",
                            "calc(50% - 12px)"
                        ],
                        left: isDirectionButtonsOverlap ? "-30px" : [
                            "0",
                            "-48px"
                        ],
                        zIndex: "1",
                        background: "white",
                        color: "primary.500",
                        _hover: {
                            color: "primaryTwo.500",
                            background: "white"
                        },
                        fontSize: [
                            "22px",
                            "24px"
                        ],
                        borderRadius: "50%",
                        width: [
                            "35px",
                            "37px"
                        ]
                    }, customPrevButtonProps), {
                        onClick: function() {
                            return handleChangeSlide("prev");
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_12__/* .ChevronLeftIcon */ .wy, {})
                    }))
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, wrapperStyle), {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MainSwipeable, {
                        index: activeIndex,
                        onChangeIndex: setActiveIndex,
                        enableMouseEvents: !activeIdx && activeIdx !== 0,
                        slideStyle: {
                            backgroundColor: "default.100",
                            border: 0,
                            boxShadow: "none",
                            paddingBottom: 10
                        },
                        style: {
                            backgroundColor: "default.100"
                        },
                        springConfig: {
                            duration: "0.8s",
                            easeFunction: "cubic-bezier(0.15, 0.3, 0.25, 1)",
                            delay: "0s"
                        },
                        children: pages.map(function(d, pi) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Grid */ .rj, {
                                templateColumns: "repeat(".concat(itemsToShow, ", 1fr)"),
                                children: d.map(function(item, index) {
                                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                            mr: index !== d.length - 1 ? spacing / 2 : 0,
                                            ml: index !== 0 ? spacing / 2 : 0,
                                            h: "100%",
                                            children: item
                                        })
                                    }, "grid-item-".concat(index.toLocaleString()));
                                })
                            }, pi);
                        })
                    }),
                    showPercent && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                        className: "hide-sm",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Slider */ .iR, {
                            "aria-label": "slider-ex-4",
                            defaultValue: 30,
                            value: percent,
                            size: "md",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .SliderTrack */ .Uj, {
                                bg: "default.200",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .SliderFilledTrack */ .Ms, {
                                    bg: "primary.500"
                                })
                            })
                        })
                    }),
                    showSlider && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .HStack */ .Ug, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        justify: "center",
                        spacing: "2",
                        mt: "8"
                    }, customSliderProps), {
                        children: pages.map(function(d, i) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Circle */ .Cd, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                opacity: i === activeIndex ? 1 : 0.5,
                                w: 2,
                                h: 2,
                                cursor: "pointer",
                                bg: dotColor
                            }, customSliderDotProps(i, activeIndex)), {
                                onClick: function() {
                                    return setActiveIndex(i);
                                }
                            }), "testimonials_evals_".concat(i));
                        })
                    }))
                ]
            }))
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Swipeable);


/***/ })

}]);